import { useMemo } from 'react';
import { getClassNameByComponent } from '../../utils';
import { appendClassName, makeBEM } from '../../../../utils';
import { ACCORDION_HEADER_CLASS_PREFIX } from '../../constants';

var useAccordionHeaderClassName = function useAccordionHeaderClassName(classPrefix, className, disabled, expanded) {
  return useMemo(function () {
    return {
      Root: appendClassName(getClassNameByComponent({
        component: 'Root',
        classPrefix: classPrefix,
        disabled: disabled,
        expanded: expanded
      }), className),
      Body: makeBEM(ACCORDION_HEADER_CLASS_PREFIX, 'Body'),
      Title: getClassNameByComponent({
        component: 'HeaderTitle',
        classPrefix: classPrefix,
        disabled: disabled,
        expanded: expanded
      }),
      IconContainer: getClassNameByComponent({
        component: 'IconContainer',
        classPrefix: classPrefix,
        disabled: disabled,
        expanded: expanded
      }),
      ExpansionIndicator: getClassNameByComponent({
        component: 'ExpansionIndicator',
        classPrefix: classPrefix,
        disabled: disabled,
        expanded: expanded
      })
    };
  }, [classPrefix, className, disabled, expanded]);
};

export default useAccordionHeaderClassName;